import _ from 'lodash';
import * as THREE from 'three';

export class tjsLight {
  _color;
  _intensity;
  _position;

  constructor(tColor, tIntensity, tPosition) {
    this._color = typeof tColor != 'undefined' && tColor != null ? tColor : 0xffffff;
    this._intensity = this._isNumber(tIntensity) == true ? Number(tIntensity) : 1;

    this.setPosition(tPosition);
  }

  setPosition(tPosition) {
    if (typeof tPosition != 'undefined' && tPosition != null) {
      let self = this;
      this._position = _.mergeWith({ x: 0, y: 0, z: 0 }, tPosition, function (value, key) {
        if (self._isNumber(key) == true) {
          return Number(key);
        }
        return Number(value);
      });
    } else {
      this._position = { x: 0, y: 0, z: 0 };
    }
  }

  DirectionalLight() {
    let directionalLight = new THREE.DirectionalLight(this._color, this._intensity);
    directionalLight.position.set(this._position.x, this._position.y, this._position.z);

    return directionalLight;
  }

  AmbientLight() {
    return new THREE.AmbientLight(this._color, this._intensity);
  }

  HemisphereLight(skyColor, groundColor) {
    return new THREE.HemisphereLight(
      typeof skyColor == 'string' ? skyColor : this._color,
      typeof groundColor == 'string' ? groundColor : this._color,
      this._intensity
    );
  }

  PointLight() {
    return new THREE.PointLight(this._color, this._intensity);
  }

  _isNumber(n) {
    n = Number(n);
    if (Number.isNaN(n) == true || Number.isFinite(n) == false) {
      return false;
    }

    return true;
  }

  get color() {
    return this._color;
  }
  set color(v) {
    this._color = v;
  }
  get intensity() {
    return this._intensity;
  }
  set intensity(v) {
    this._intensity = v;
  }
  get position() {
    return this._position;
  }
  set position(v) {
    this._position = v;
  }
}
